import { AccordionType, CaretType } from '../types/common.types';

export interface Accordion {
  targetContent?: string;
  caretType: CaretType;
  state: boolean;
  type: AccordionType;
  id?: string;
  showLabel?: boolean;
  modalTitle?: string;
  toggleLabels: ToggleLabel;
}

export interface ToggleLabel {
  hide: string;
  view: string;
}
